// extracted by mini-css-extract-plugin
export default {"form__text-areas":"TextAreas_form__text-areas__7HE5f","input-field":"TextAreas_input-field__g8eKG"};